var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebookBig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 94,
    viewBox: "0 0 95 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_804_8719)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M94.625 47C94.625 21.0426 73.5824 0 47.625 0C21.6676 0 0.625 21.0426 0.625 47C0.625 70.4587 17.8121 89.9031 40.2813 93.429V60.5859H28.3477V47H40.2813V36.6453C40.2813 24.8659 47.2982 18.3594 58.0339 18.3594C63.1745 18.3594 68.5547 19.2773 68.5547 19.2773V30.8437H62.6283C56.79 30.8437 54.9688 34.467 54.9688 38.1875V47H68.0039L65.9201 60.5859H54.9688V93.429C77.4379 89.9031 94.625 70.4587 94.625 47Z",
    fill: "#1877F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.9191 60.5859L68.0029 47H54.9678V38.1875C54.9678 34.4706 56.789 30.8438 62.6273 30.8438H68.5537V19.2773C68.5537 19.2773 63.1753 18.3594 58.0329 18.3594C47.2972 18.3594 40.2803 24.8659 40.2803 36.6453V47H28.3467V60.5859H40.2803V93.429C45.1465 94.1903 50.1015 94.1903 54.9678 93.429V60.5859H65.9191Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_804_8719"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 94,
    height: 94,
    fill: "white",
    transform: "translate(0.625)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookBig);
export default __webpack_public_path__ + "static/media/FacebookBig.01f90657089230577f01e9188bcc14b4.svg";
export { ForwardRef as ReactComponent };